/* Omiloa Joyería — theme.js */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var overlay = $('[data-overlay]');

  /* ---------------- Drawers ---------------- */
  var openDrawer = null;
  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
  }
  function close(drawer) {
    drawer = drawer || openDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked');
    openDrawer = null;
  }
  overlay && overlay.addEventListener('click', function () { close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); open($('[data-menu-drawer]')); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); close(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && window.theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      refreshCart().then(function () { open($('[data-cart-drawer]')); });
    }
  });

  /* ---------------- Carrito ---------------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refreshCart() {
    var page = $('[data-cart-page]');
    if (page) {
      return fetch(window.location.pathname + '?t=' + Date.now())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (fresh) page.innerHTML = fresh.innerHTML;
          var c = page.querySelector('[data-cart-contents]');
          if (c) updateCount(parseInt(c.getAttribute('data-item-count'), 10) || 0);
          refreshDrawerOnly();
        });
    }
    return refreshDrawerOnly();
  }

  function refreshDrawerOnly() {
    var inner = $('[data-cart-drawer-inner]');
    return fetch(window.theme.routes.root_url.replace(/\/$/, '') + '/?section_id=cart-drawer&t=' + Date.now())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        if (inner && fresh) inner.innerHTML = fresh.innerHTML;
        var c = doc.querySelector('[data-cart-contents]');
        if (c) updateCount(parseInt(c.getAttribute('data-item-count'), 10) || 0);
      });
  }

  function changeLine(line, quantity) {
    return fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10)) })
    }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { e.preventDefault(); qtyBtn.disabled = true; changeLine(qtyBtn.getAttribute('data-cart-qty'), qtyBtn.getAttribute('data-qty-value')); }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); rm.disabled = true; changeLine(rm.getAttribute('data-cart-remove'), 0); }
  });

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 400); }, 2600);
  }

  /* Agregar al carrito (ficha, tarjetas, upsell) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-product-form');
    if (!form) return;
    e.preventDefault();
    var btns = $$('[type="submit"], [data-add-to-cart]', form);
    if (form.id) btns = btns.concat($$('[form="' + form.id + '"]'));
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;

    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'No se pudo agregar');
        if (window.theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
          return refreshCart().then(function () { open($('[data-cart-drawer]')); });
        }
        if ($('[data-cart-page]')) return refreshCart();
        window.location.href = window.theme.routes.cart_url;
      })
      .catch(function (error) {
        if (err) { err.textContent = error.message; err.hidden = false; } else { toast(error.message); }
      })
      .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  });

  /* ---------------- Producto ---------------- */
  function formatMoney(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'MXN';
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = $('[data-variant-id]', section);
    var qtyInput = $('[data-qty-input]', section);

    /* Variantes */
    var picker = $('[data-variant-picker]', section);
    if (picker && data) {
      picker.addEventListener('change', function () {
        var selected = $$('fieldset', picker).map(function (fs) {
          var c = $('input:checked', fs); return c ? c.value : null;
        });
        $$('[data-option-value]', picker).forEach(function (el, i) { el.textContent = selected[i]; });
        var variant = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        updateVariant(variant);
      });
    }

    function updateVariant(variant) {
      var atcs = $$('[data-add-to-cart]', section);
      if (!variant) {
        atcs.forEach(function (b) { b.disabled = true; });
        $$('[data-add-to-cart-text]', section).forEach(function (t) { t.textContent = 'No disponible'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      $$('[data-price-current]', section).forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      $$('[data-price-compare]', section).forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = formatMoney(variant.compare_at_price); });
      $$('[data-price-save]', section).forEach(function (el) { el.hidden = !onSale; });
      $$('[data-price-save-amount]', section).forEach(function (el) { if (onSale) el.textContent = formatMoney(variant.compare_at_price - variant.price); });
      $$('[data-price]', section).forEach(function (el) { el.classList.toggle('price--sale', !!onSale); });
      atcs.forEach(function (b) { b.disabled = !variant.available; });
      $$('[data-add-to-cart-text]', section).forEach(function (t) {
        if (!t.dataset.label) t.dataset.label = t.textContent;
        t.textContent = variant.available ? t.dataset.label : 'Agotado';
      });
      if (variant.featured_media) goToMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* Cantidad */
    var minus = $('[data-qty-minus]', section), plus = $('[data-qty-plus]', section);
    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, n);
      $$('[data-offer-qty]', section).forEach(function (t) {
        t.classList.toggle('is-selected', parseInt(t.getAttribute('data-offer-qty'), 10) === parseInt(qtyInput.value, 10));
      });
    }
    minus && minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
    plus && plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    qtyInput && qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10) || 1); });

    /* Niveles de oferta: al hacer clic se pone esa cantidad */
    $$('[data-offer-qty]', section).forEach(function (tier) {
      tier.addEventListener('click', function () {
        setQty(parseInt(tier.getAttribute('data-offer-qty'), 10));
        var buy = $('.product__buy', section);
        if (buy && window.innerWidth < 990) buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* Galería */
    var main = $('[data-gallery-main]', section);
    var thumbs = $$('[data-gallery-thumbs] .gallery__thumb', section);
    var current = $('[data-gallery-current]', section);
    function goTo(i) { if (main) main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); }
    function goToMedia(id) {
      var slides = $$('.gallery__slide', section);
      var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(id); });
      if (idx > -1) goTo(idx);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
    if (main) {
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          if (current) current.textContent = i + 1;
        });
      }, { passive: true });
    }

    /* Botón fijo en móvil */
    var sticky = $('[data-sticky-atc]', section);
    var buyBlock = $('.product__buy', section);
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(buyBlock);
    }
  });

  /* ---------------- Cuenta atrás ---------------- */
  function parseEnd(str) {
    // "AAAA-MM-DD HH:MM" en hora de Ciudad de México (UTC-6, sin horario de verano)
    var m = (str || '').match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return null;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] + 6, +m[5], 59);
  }
  function tick() {
    $$('[data-countdown]').forEach(function (cd) {
      var end;
      if (cd.getAttribute('data-mode') === 'fixed') {
        end = parseEnd(cd.getAttribute('data-end'));
      }
      if (!end || end < Date.now()) {
        var d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime();
      }
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var hEl = $('[data-cd-h]', cd), mEl = $('[data-cd-m]', cd), sEl = $('[data-cd-s]', cd);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------------- Carruseles ---------------- */
  $$('[data-carousel]').forEach(function (track) {
    var wrap = track.parentElement;
    var prev = $('[data-carousel-prev]', wrap), next = $('[data-carousel-next]', wrap), count = $('[data-carousel-count]', wrap);
    var step = function () { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth; };
    function update() {
      if (!count) return;
      var total = track.children.length;
      var perView = Math.max(1, Math.round(track.clientWidth / step()));
      var pages = Math.max(1, Math.ceil(total / perView));
      var page = Math.min(pages, Math.round(track.scrollLeft / (step() * perView)) + 1);
      count.textContent = page + ' / ' + pages;
      var nav = count.parentElement;
      if (nav) nav.hidden = pages <= 1;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------------- Hero slider ---------------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    var dots = $$('[data-slider-dots] button', slider);
    if (!track || dots.length < 2) return;
    var index = 0;
    function go(i) { index = (i + dots.length) % dots.length; track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' }); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth); index = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
    var speed = parseInt(slider.getAttribute('data-autoplay'), 10);
    if (speed > 0) setInterval(function () { if (!document.hidden) go(index + 1); }, speed * 1000);
  });

  /* ---------------- Barra de anuncios rotativa ---------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------------- Ordenar colección ---------------- */
  var sort = $('[data-sort-by]');
  sort && sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
